/*
  Mobile menu drill-down (sections/totl-header.liquid, "Mobile menu" setting).
  A top-level link with nested links opens its own screen, which slides in
  over the main list; "Main menu" slides back. The menu returns to the main
  list whenever it closes.
*/
(function () {
  function init(root) {
    if (root.dataset.tbMnavBound === 'true') return;
    root.dataset.tbMnavBound = 'true';

    var openers = root.querySelectorAll('[data-tb-mnav-open]');
    var current = null;
    var currentOpener = null;

    function show(panel, opener) {
      panel.hidden = false;
      // Next frame so the slide-in transition runs from the off-screen state.
      window.requestAnimationFrame(function () {
        root.classList.add('is-sub-open');
        panel.classList.add('is-active');
      });
      opener.setAttribute('aria-expanded', 'true');
      current = panel;
      currentOpener = opener;
      var back = panel.querySelector('[data-tb-mnav-back]');
      if (back) back.focus({ preventScroll: true });
    }

    function back(instant) {
      if (!current) return;
      var panel = current;
      var opener = currentOpener;
      root.classList.remove('is-sub-open');
      panel.classList.remove('is-active');
      if (opener) opener.setAttribute('aria-expanded', 'false');
      current = null;
      currentOpener = null;
      if (instant) {
        panel.hidden = true;
      } else {
        window.setTimeout(function () { if (!panel.classList.contains('is-active')) panel.hidden = true; }, 320);
        if (opener) opener.focus({ preventScroll: true });
      }
    }

    openers.forEach(function (opener) {
      opener.addEventListener('click', function () {
        var panel = document.getElementById(opener.getAttribute('data-tb-mnav-open'));
        if (panel) show(panel, opener);
      });
    });

    root.querySelectorAll('[data-tb-mnav-back]').forEach(function (button) {
      button.addEventListener('click', function () { back(false); });
    });

    // Back to the main list when the menu closes.
    var menu = root.closest('[data-totl-nav-menu]');
    if (menu && window.MutationObserver) {
      new MutationObserver(function () {
        if (!menu.classList.contains('w--open')) back(true);
      }).observe(menu, { attributes: true, attributeFilter: ['class'] });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-tb-mnav]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
